/**
 * WPrezentationCards — polskie tłumaczenia (wariant kart).
 *
 * Stringi UI chrome (nav, alty, CTA). Tytuły slajdów pochodzą z backendu
 * per locale (admin edytuje slajd osobno dla każdego języka).
 */
import type { DeepString } from "@/lib/i18n";

export const pl = {
  empty: "Brak slajdów do wyświetlenia.",
  cta: "Zobacz więcej",
  openSlideAria: "Otwórz",
  youtubeTitleFallback: "Film YouTube",
} as const;

export type WPrezentationCardsTranslations = DeepString<typeof pl>;
